import React, { Component } from 'react';
import './Timeline.css';


class Timeline extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="steps center  animated fadeIn  row">
        <div className="col s12">
        <ul className="timeline" id="timeline">
          <li className={"li " + (this.props.cart || this.props.delivery ||  this.props.confirmation ||  this.props.completed  ? 'complete' : '') }>
            <div className="timestamp">
              <span className="author">Ingresar</span>
            </div>
            <div className="status">

            </div>
          </li>
          <li className={"li " + (this.props.delivery ||  this.props.confirmation ||  this.props.completed ? 'complete' : '') }>
            <div className="timestamp">
              <span className="author">Envio</span>
            </div>
            <div className="status">
            </div>
          </li>
          <li className={"li " + (this.props.confirmation ||  this.props.completed ? 'complete' : '') }>
            <div className="timestamp">
              <span className="author">Ordenar</span>
            </div>
            <div className="status">
            </div>
          </li>
         </ul>
      </div>
      </div>

    );
  }
}


export default Timeline;



// WEBPACK FOOTER //
// ./src/components/timeline/Timeline.js